const ANGLE_RAD_90 = 90 * Math.PI / 180;
const ANGLE_RAD_270 = 270 * Math.PI / 180;

class Shapes {
    constructor(onChange = () => { }, noUndo = false) {
        this.noUndo = noUndo;
        this.id = 0;
        this.isSaving = false;
        this.strokes = [];
        this.stamps = [];
        this.history = [];
        this.onChange = onChange;
        this.currentStrokeIndex = 0;
        this.savedStrokes = [];
        this.saverCanvasContext = null;
        if (this.noUndo) {
            document.getElementById("undobtn").style.display = 'none';
        }
    }

    clear() {
        this.strokes = [];
        this.stamps = [];
        this.history = [];
        this.savedStrokes = [];
        this.currentStrokeIndex = 0;
        this.onChange();
    }

    undo() {
        if (!this.history.length) {
            return null;
        }
        const lastShape = this.history.pop();
        if (lastShape.isStroke) {
            this.removeStroke(lastShape.index);
        } else {
            this.removeStamp(lastShape.index);
        }
        this.onChange();
        return lastShape;
    }

    removeStroke(index) {
        this.strokes.splice(index, 1);
        let i = 0;
        for (const stroke of this.strokes) {
            stroke.index = i;
            stroke.points = stroke.points.map(obj => ({ ...obj, strokeIndex: i }));
            i++;
        }
    }

    removeStamp(index) {
        this.stamps.splice(index, 1);
        this.stamps = this.stamps.map((obj, i) => ({ ...obj, index: i }));
    }

    getCurrentStroke() {
        return this.strokes[this.currentStrokeIndex];
    }

    startStroke(point, ready = false) {
        this.addStrokePoint(point, this.strokes.length, ready);
    }

    addPoint(point) {
        this.addStrokePoint(point, this.currentStrokeIndex);
    }

    getPreviousPoint(point) {
        return point.index > 0 ? this.strokes[point.strokeIndex].points[point.index - 1] : point;
    }

    addStrokePoint(point, strokeIndex, ready = false) {
        this.currentStrokeIndex = strokeIndex;
        point.strokeIndex = strokeIndex;
        if (strokeIndex in this.strokes) {
            point.index = this.strokes[strokeIndex].points.length;
            this.strokes[strokeIndex].points.push(point);
        } else {
            point.index = 0;
            const stroke = {
                isStroke: true,
                index: strokeIndex,
                points: [point],
                imageData: null,
                startTime: point.time,
                startLoopTime: point.loopTime,
                instrument: point.instrument,
                color: point.color,
                hexColor: point.hexColor.toLowerCase(),
                playerReady: ready,
                id: this.id
            };
            this.strokes[strokeIndex] = stroke;
            this.history.push(stroke);
            this.id++;
        }
        if (point.index > 0) {
            const previousPoint = this.getPreviousPoint(point);
            const theta = Math.atan2(
                previousPoint.y - point.y,
                previousPoint.x - point.x
            );
            point.p1x = point.x + (Math.cos(theta + ANGLE_RAD_90) * point.radius);
            point.p1y = point.y + (Math.sin(theta + ANGLE_RAD_90) * point.radius);
            point.p2x = point.x + (Math.cos(theta + ANGLE_RAD_270) * point.radius);
            point.p2y = point.y + (Math.sin(theta + ANGLE_RAD_270) * point.radius);
        }
        this.onChange();
    }

    getById(id) {
        const length = this.history.length;
        for (let i = length - 1; i >= 0; i--) {
            if (this.history[i].id === id) {
                return this.history[i];
            }
        }
        return null;
    }

    addStamp(point, color) {
        point.stamp = true;
        point.color = color;
        point.index = this.stamps.length;
        point.id = this.id;
        point.isStroke = false;
        this.stamps.push(point);
        this.history.push(point);
        this.id++;
        this.onChange();
    }

    setStrokePlayer(strokeId) {
        for (const stroke of this.strokes) {
            if (stroke.id === strokeId) {
                stroke.playerReady = true;
                break;
            }
        }
    }

    save(canvas, isStamp = false) {
        const id = isStamp ? this.stamps[this.stamps.length - 1].id : this.strokes[this.currentStrokeIndex].id;
        const w = canvas.width;
        const h = canvas.height;

        if (this.noUndo) {
            if (!this.saverCanvasContext) {
                const c = document.createElement('canvas');
                this.saverCanvasContext = c.getContext('2d');
            }
            this.saverCanvasContext.canvas.width = w;
            this.saverCanvasContext.canvas.height = h;
            this.saverCanvasContext.drawImage(canvas, 0, 0);
            const shape = this.getById(id);
            shape.imageData = {
                image: this.saverCanvasContext.canvas,
                width: w,
                height: h,
                loaded: true
            };
        } else {
            canvas.toBlob((blob) => {
                const newImg = document.createElement('img');
                const url = URL.createObjectURL(blob);
                const data = {
                    image: newImg,
                    width: w,
                    height: h,
                    loaded: false
                };
                newImg.onload = function () {
                    // no longer need to read the blob so it's revoked
                    URL.revokeObjectURL(url);
                    data.loaded = true;
                };
                newImg.src = url;
                const shape = this.getById(id);
                shape.imageData = data;
            });
        }
    }
}
export { Shapes };